
// import { useState } from "react";
// import { X } from "lucide-react";
// import { Input } from "@/components/ui/input";
// import { Button } from "@/components/ui/button";
// import { Badge } from "@/components/ui/badge";

// interface ProfileSkillsEditorProps {
//   isEditing: boolean;
//   localSkills: string[];
//   // handleRemoveSkill: (skillToRemove: string) => void;
//   // handleAddSkill: () => void;
//   newSkill: string;
//   setNewSkill: (skill: string) => void;
// }

// export const ProfileSkillsEditor = ({
//   isEditing,
//   localSkills,
//   // handleRemoveSkill,
//   // handleAddSkill,
//   newSkill,
//   setNewSkill
// }: ProfileSkillsEditorProps) => {
//   return (
//     <div className="mb-6">
//       <h3 className="text-sm font-medium text-gray-600 mb-2 text-center">Skills</h3>
//       <div className="flex flex-wrap justify-center gap-2 mb-3">
//         {localSkills.map((skill, index) => (
//           <Badge 
//             key={index} 
//             variant="secondary"
//             className="hover-scale"
//           >
//             {skill}
//             {isEditing && (
//               <button 
//                 className="ml-1 text-gray-500 hover:text-gray-700"
//                 // onClick={() => handleRemoveSkill(skill)}
//               >
//                 <X className="w-3 h-3" />
//               </button>
//             )}
//           </Badge>
//         ))}
//       </div>
//       {isEditing && (
//         <div className="flex gap-2 mt-2">
//           <Input
//             value={newSkill}
//             onChange={(e) => setNewSkill(e.target.value)}
//             placeholder="Add a skill"
//             className="text-sm"
//             // onKeyDown={(e) => e.key === 'Enter' && handleAddSkill()}
//           />
//           {/* <Button onClick={handleAddSkill} size="sm" variant="outline">Add</Button> */}
//         </div>
//       )}
//     </div>
//   );
// };



import { Input } from "@/components/ui/input";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { X } from "lucide-react";

interface ProfileSkillsEditorProps {
  isEditing: boolean;
  localSkills: string[];
  handleRemoveSkill: (skillToRemove: string) => void;
  handleAddSkill: () => void;
  newSkill: string;
  setNewSkill: (skill: string) => void;
}

export const ProfileSkillsEditor = ({
  isEditing,
  localSkills,
  handleRemoveSkill,
  handleAddSkill,
  newSkill,
  setNewSkill,
}: ProfileSkillsEditorProps) => {
  return (
    <div className="mb-6">
      <h3 className="text-sm font-medium text-gray-600 mb-2 text-center">
        Skills
      </h3>
      <div className="flex flex-wrap justify-center gap-2 mb-3">
        {localSkills.map((skill, index) => (
          <Badge key={index} variant="secondary" className="hover-scale">
            {skill}
            {isEditing && (
              <button
                className="ml-1 text-gray-500 hover:text-gray-700"
                onClick={() => handleRemoveSkill(skill)}
              >
                <X className="w-3 h-3" />
              </button>
            )}
          </Badge>
        ))}
      </div>
      {isEditing && (
        <div className="flex gap-2 mt-2">
          <Input
            value={newSkill}
            onChange={(e) => setNewSkill(e.target.value)}
            placeholder="Add a skill"
            className="text-sm"
            onKeyDown={(e) => e.key === "Enter" && handleAddSkill()}
          />
          <Button onClick={handleAddSkill} size="sm" variant="outline">
            Add
          </Button>
        </div>
      )}
    </div>
  );
};